import { Component, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core';
import { WorkingAreaResponseModel } from 'src/app/models/workingArea-response.model';
import { SupplierService } from 'src/app/services/supplier.services';
import { InduMapComponent } from 'src/app/shared/components/indu-map/indu-map.component';
import { AreaTypeEnum } from 'src/app/shared/enumerators/area-type.enum';
import { InduMapComponent as InduMapComponent_1 } from '../../../shared/components/indu-map/indu-map.component';

@Component({
  selector: 'app-supplier-zone-filter',
  templateUrl: './supplier-zone-filter.component.html',
  styleUrls: ['./supplier-zone-filter.component.scss'],
  imports: [InduMapComponent_1]
})
export class SupplierZoneFilterComponent {
  private readonly supplierSvc = inject(SupplierService);

  @ViewChild(InduMapComponent) mapComponent!: InduMapComponent;
  @Output() closeModal = new EventEmitter<void>();
  @Output() setFilteredZone = new EventEmitter<any>();

  @Input() filterZone: WorkingAreaResponseModel | undefined;

  drawZone: boolean = true;
  center: google.maps.LatLngLiteral = { lat: -31.4135, lng: -64.1810 };
  circleCenter: any[] = [];

  ngOnInit() {
    if (this.filterZone) {
      this.center = {
        lat: this.filterZone.latitude,
        lng: this.filterZone.longitude,
      };
      this.circleCenter = [this.toCircle(this.filterZone)];
    }
  }

  onSubmit() {
    if (this.filterZone) {
      this.setFilteredZone.emit(this.filterZone);
    }
  }

  setfilteredZone(zone: any) {
    if (zone) {
      this.filterZone = zone;
      // Hand the drawn zone back to the map as an editable circle, so the user can resize and move it.
      this.circleCenter = [this.toCircle(zone)];
    }
  }

  cancelClick() {
    this.filterZone = undefined;
    this.circleCenter = [];
    this.setFilteredZone.emit(this.filterZone);
    this.closeModal.emit();
  }

  private toCircle(zone: WorkingAreaResponseModel) {
    return {
      id: zone.id ?? 'zone-filter',
      lat: zone.latitude,
      lng: zone.longitude,
      radiusKm: zone.radiusKm,
      options: {
        fillColor: 'green',
        strokeColor: 'green',
        areaType: AreaTypeEnum.Inclusion,
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillOpacity: 0.3,
        // Not clickable: a click would offer to delete the zone, which this filter does not handle.
        clickable: false,
        editable: true,
        draggable: true,
        zIndex: 1,
      },
    };
  }
}
